import { render, staticRenderFns } from "./ActivityPageForm.vue?vue&type=template&id=e23c53ae&scoped=true"
import script from "./ActivityPageForm.vue?vue&type=script&lang=js"
export * from "./ActivityPageForm.vue?vue&type=script&lang=js"
import style0 from "./ActivityPageForm.vue?vue&type=style&index=0&id=e23c53ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e23c53ae",
  null
  
)

export default component.exports